import { Code, useTheme, type CodeProps } from '@chakra-ui/react'
import { rgba } from 'polished'
import React from 'react'

interface Props extends Omit<CodeProps, 'variant'> {}

const Component = React.forwardRef((props: Props, ref: React.Ref<any>) => {
  const theme = useTheme()
  const bgColor = rgba(theme.colors.text?.normal, 0.1)

  return (
    <Code
      ref={ref}
      bg={bgColor}
      color='text.normal'
      {...props}
    />
  )
})

export {
  Component as Code,
  type Props as CodeProps
}